module.exports = `${require.publicPath}101.0cc8c508.png`;